<div class="site-selection">
    <div class="choose-site">
        <h2>Choose site(s)</h2>
        <div class="search-site">
            <input class="form-control input-rounded" placeholder="type to search"/>
            <i class="fa fa-search"></i>
        </div>
    </div>
    <ul class="site-selection-wrapper">
        <li>
            <div class="site-icon">
                <i class="fa fa-map-marker"></i>
            </div>
            <div class="site-selection-data">
                <h3 class="site-name" title="Anr Software Pvt Ltd.">Anr Software Pvt Ltd.</h3>
                <div class="site-address" title="B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.">B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.</div>
            </div>
        </li>
        <li>
            <div class="site-icon">
                <i class="fa fa-map-marker"></i>
            </div>
            <div class="site-selection-data">
                <h3 class="site-name" title="Anr Software Pvt Ltd.">Anr Software Pvt Ltd.</h3>
                <div class="site-address" title="B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.">B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.</div>
            </div>
        </li>
        <li>
            <div class="site-icon">
                <i class="fa fa-map-marker"></i>
            </div>
            <div class="site-selection-data">
                <h3 class="site-name" title="Anr Software Pvt Ltd.">Anr Software Pvt Ltd.</h3>
                <div class="site-address" title="B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.">B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.</div>
            </div>
        </li>
        <li>
            <div class="site-icon">
                <i class="fa fa-map-marker"></i>
            </div>
            <div class="site-selection-data">
                <h3 class="site-name" title="Anr Software Pvt Ltd.">Anr Software Pvt Ltd.</h3>
                <div class="site-address" title="B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.">B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.</div>
            </div>
        </li>
        <li>
            <div class="site-icon">
                <i class="fa fa-map-marker"></i>
            </div>
            <div class="site-selection-data">
                <h3 class="site-name" title="Anr Software Pvt Ltd.">Anr Software Pvt Ltd.</h3>
                <div class="site-address" title="B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.">B-103 & 104, Noida Sector - 63, Uttar Pradesh, India.</div>
            </div>
        </li>
    </ul>
</div>
